/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */

import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.reservation = (await import('./pages/Reservation')).Reservation;
    Components.delivery = (await import('./pages/Delivery')).Delivery;
    Components.clearCallback = (await import('./pages/ClearCallback')).ClearCallback;
    Components.clearVerification = (await import('./pages/ClearVerification')).ClearVerification;
    Components.clearCallbackV2 = (await import('./pages/ClearCallbackV2')).ClearCallbackV2;
    Components.selfDropoff = (await import('./pages/SelfDropoff')).SelfDropoff;
    Components.reservationDetails = (await import('./pages/ReservationDetails')).ReservationDetails;
    Components.manageReservation = (await import('./pages/ManageReservation')).ManageReservation;
    Components.manageReservationV2 = (await import('./pages/ManageReservationV2')).ManageReservationV2;
    Components.cancelReservation = (await import('./pages/CancelReservation')).CancelReservation;
    Components.product = (await import('./pages/Product')).Product;
    Components.usedEquipment = (await import('./pages/UsedEquipment')).UsedEquipment;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  reservation: {
    name: 'Reservation',
    componentName: 'Reservation',
    chunk: () => import('./pages/Reservation'),
    get component() {
      return ssr
        ? serverPages.reservation
        : currentRouteName === 'Reservation'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Reservation })));
    },
    path: '/:context?/p/rental/reservations/:slug?/:itemId',
    channel: null
  },
  delivery: {
    name: 'Delivery',
    componentName: 'Delivery',
    chunk: () => import('./pages/Delivery'),
    get component() {
      return ssr
        ? serverPages.delivery
        : currentRouteName === 'Delivery'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Delivery })));
    },
    path: '/:context?/p/rental/delivery/:slug?/:itemId',
    channel: null
  },
  clearCallback: {
    name: 'ClearCallback',
    componentName: 'ClearCallback',
    chunk: () => import('./pages/ClearCallback'),
    get component() {
      return ssr
        ? serverPages.clearCallback
        : currentRouteName === 'ClearCallback'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ClearCallback })));
    },
    path: '/:context?/rental/clear-verification/callback',
    channel: null
  },
  clearVerification: {
    name: 'ClearVerification',
    componentName: 'ClearVerification',
    chunk: () => import('./pages/ClearVerification'),
    get component() {
      return ssr
        ? serverPages.clearVerification
        : currentRouteName === 'ClearVerification'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ClearVerification })));
    },
    path: '/:context?/rental/clear-verification/:clearState',
    channel: null
  },
  clearCallbackV2: {
    name: 'ClearCallbackV2',
    componentName: 'ClearCallbackV2',
    chunk: () => import('./pages/ClearCallbackV2'),
    get component() {
      return ssr
        ? serverPages.clearCallbackV2
        : currentRouteName === 'ClearCallbackV2'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ClearCallbackV2 })));
    },
    path: '/:context?/rental/clear-verification/v2/callback/:uuid',
    channel: null
  },
  selfDropoff: {
    name: 'SelfDropoff',
    componentName: 'SelfDropoff',
    chunk: () => import('./pages/SelfDropoff'),
    get component() {
      return ssr
        ? serverPages.selfDropoff
        : currentRouteName === 'SelfDropoff'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SelfDropoff })));
    },
    path: '/:context?/rental/self-dropoff/:storeId',
    channel: null
  },
  reservationDetails: { // TODO: Remove once transitioned off
    name: 'ReservationDetails',
    componentName: 'ReservationDetails',
    chunk: () => import('./pages/ReservationDetails'),
    get component() {
      return ssr
        ? serverPages.reservationDetails
        : currentRouteName === 'ReservationDetails'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ReservationDetails })));
    },
    path: '/:context?/p/rental/reservationDetails',
    channel: null
  },
  manageReservation: {
    name: 'ManageReservation',
    componentName: 'ManageReservation',
    chunk: () => import('./pages/ManageReservation'),
    get component() {
      return ssr
        ? serverPages.manageReservation
        : currentRouteName === 'ManageReservation'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ManageReservation })));
    },
    path: '/:context?/rental/manage-reservation/:uuid/:reservationId/:storeId',
    channel: null
  },
  manageReservationV2: {
    name: 'ManageReservationV2',
    componentName: 'ManageReservationV2',
    chunk: () => import('./pages/ManageReservationV2'),
    get component() {
      return ssr
        ? serverPages.manageReservationV2
        : currentRouteName === 'ManageReservationV2'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ManageReservationV2 })));
    },
    path: '/:context?/rental/manage-reservation/v2/:uuid/:reservationId/:storeId',
    channel: null
  },
  cancelReservation: {
    name: 'CancelReservation',
    componentName: 'CancelReservation',
    chunk: () => import('./pages/CancelReservation'),
    get component() {
      return ssr
        ? serverPages.cancelReservation
        : currentRouteName === 'CancelReservation'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.CancelReservation })));
    },
    path: '/:context?/rental/cancel-reservation/:cancellationId/:reservationNumber',
    channel: null
  },
  product: {
    name: 'Product',
    componentName: 'Product',
    chunk: () => import('./pages/Product'),
    get component() {
      return ssr
        ? serverPages.product
        : currentRouteName === 'Product'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Product })));
    },
    path: '/:context?/p/rental/:slug?/:itemId',
    channel: null
  },
  usedEquipment: {
    name: 'UsedEquipment',
    componentName: 'UsedEquipment',
    chunk: () => import('./pages/UsedEquipment'),
    get component() {
      return ssr
        ? serverPages.usedEquipment
        : currentRouteName === 'UsedEquipment'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.UsedEquipment })));
    },
    path: '/:context?/rental/used-equipment',
    channel: null
  },

});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();

  return componentModule[route.componentName];
};
